/**
 * @param {string} value like "Some long string"
 * @param {number} value like 10 or 50
 * @returns {string} like 'Some long...' or 'Some long string'
 */
export default (value, len) => {
    value = value.trim();
    if (value.length >= len) {
        value = value.slice(0, len).trim() + '...';
    }
    return value;
};
